import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./features/login/loginSlice";
import adsReducer from "./features/sharingAdvertisment/SharingAdSlice";
import userReducer from "./features/user/userSlice";
import countryReducer from "./features/country/countrySlice";
import languageReducer from "./features/language/language";
import tournamentReducer from "./features/tournament/tournamentSlice";
import eventReducer from "./features/event/eventSlice";
import notificationReducer from "./features/notification/notificationSlice";
import loaderReducer from "./features/loader/loaderSlice";
import gameTypeReducer from "./features/gameType/gameTypeSlice";
import notificationsReducer from "./features/notifications/notificationsSlice";
import chatNotificationsReducer from "./features/chatNotifications/chatNotificationsSlice";
import categoryReducer from './features/category/categorySlice';
import productReducer from "./features/product/productSlice";
import bannerReducer from "./features/banner/bannerSlice";
import playerStoreReducer from "./features/playerStore/playerStoreSlice";
import cartReducer from "./features/cart/cartSlice";
import gamificationReducer from "./features/gamification/gamificationSlice"
import gameReducer from "./features/duelsGameSelection/gameSlice";
import joinRequestReducer, {
  DUELS_JOIN_REQUEST_STORAGE_KEY,
} from "./features/duelsJoinRequest/joinRequestSlice";
import activeRoomsReducer from "./features/duelsActiveRooms/activeRoomsSlice";
import duelsActiveMatchReducer from "./features/duelsActiveMatch/activeMatchSlice";
import { setLocalStorageData } from "./shared/commonFunction";

const joinRequestPersistenceMiddleware = (storeAPI) => (next) => (action) => {
  const result = next(action);

  if (action.type.startsWith("joinRequest/")) {
    const joinRequestState = storeAPI.getState().joinRequest;
    setLocalStorageData(
      DUELS_JOIN_REQUEST_STORAGE_KEY,
      JSON.stringify(joinRequestState)
    );
  }

  return result;
};

export const store = configureStore({
  reducer: {
    login: loginReducer,
    user: userReducer,
    country: countryReducer,
    language: languageReducer,
    tournament: tournamentReducer,
    event: eventReducer,
    notification: notificationReducer,
    loader: loaderReducer,
    gameType: gameTypeReducer,
    notifications: notificationsReducer,
    chatNotifications: chatNotificationsReducer,
    ads: adsReducer,
    category: categoryReducer,
    product: productReducer,
    banner: bannerReducer,
    playerStore: playerStoreReducer,
    cart: cartReducer,
    gamification: gamificationReducer,
    game: gameReducer,
    joinRequest: joinRequestReducer,
    activeRooms: activeRoomsReducer,
    duelsActiveMatch: duelsActiveMatchReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(joinRequestPersistenceMiddleware),
});
